import { useNavigate } from 'react-router-dom';
import AchemedSimboloAzul from '../assets/img/achemed-simbolo-azul.png';

export default function Unauthorized() {
  const navigate = useNavigate();

  return (
    <div className='d-flex justify-content-center align-items-center gap-3' style={{ flexDirection: 'column', marginTop: '20vh' }}>
      <img src={AchemedSimboloAzul} width={50} alt="Achemed" />
      <h2>Página não encontrada</h2>
      <button onClick={() => navigate('/dashboard')}>Voltar para a página inicial</button>
    </div>
  )
}
